import { debounce, isEqual } from 'lodash';
import { isFieldEmpty } from '@core_utils/subComponent/subComponent';

export default {
    name: 'translation-sub-component-common-mixin',
    data () {
        return {
            is_edited_sub_data_contents: false,
            is_edited_sub_element_contents: false
        }
    },
    computed: {},
    watch: {},
    created () {},
    mounted () {},
    methods: {
        changeEditingSubDataContents: debounce(function () {
            let _editing_check_field = []
            if (this.sub_type === 'textbox') {
                _editing_check_field.push('placeholder', 'placeholder_ca', 'placeholder_ea')
            }

            const _editing_check_field_object = _editing_check_field.reduce((_field_object, _field) => {
                _field_object[_field] = null
                return _field_object
            }, {})

            let _is_sub_data_contents_edited = Object.entries(this.sub_data.sub_data_contents).reduce((_is_edited_structure, [ _content_key ]) => {
                if (!_is_edited_structure) {
                    const _origin_campare_data = Object.entries(_editing_check_field_object).reduce((_campare_object, [ _campare_key ]) => {
                        if (_editing_check_field.includes(_content_key)) _campare_object[_campare_key] = this.sub_data.sub_data_contents[_campare_key]
                        return _campare_object
                    }, {})

                    const _editable_campare_data = Object.entries(_editing_check_field_object).reduce((_campare_object, [ _campare_key ]) => {
                        if (_editing_check_field.includes(_content_key)) _campare_object[_campare_key] = this.editable_sub_data_contents[_campare_key]
                        return _campare_object
                    }, {})

                    _is_edited_structure = !isEqual(_editable_campare_data, _origin_campare_data);
                }
                return _is_edited_structure
            }, false)

            this.validate_sub_type_translation()
            this.is_edited_sub_data_contents = _is_sub_data_contents_edited
        }),
        changeEditingSubDataContentsStructure: debounce(function () {
            let _editing_check_field = []
            if (this.sub_type === 'radio') {
                _editing_check_field.push('text', 'text_ca', 'text_ea')
            } else if (this.sub_type === 'checkbox') {
                _editing_check_field.push('text', 'text_ca', 'text_ea', 'placeholder', 'placeholder_ca', 'placeholder_ea')
            } else if (this.sub_type === 'checkbox') {
                _editing_check_field.push('placeholder', 'placeholder_ca', 'placeholder_ea')
            } else if (this.sub_type === 'table') {
                _editing_check_field.push('text', 'text_ca', 'text_ea', 'dropdown', 'placeholder')
            }
			
            const _editing_check_field_object = _editing_check_field.reduce((_field_object, _field) => {
                _field_object[_field] = null
                return _field_object
            }, {})

            let _is_sub_data_contents_edited = this.sub_data.sub_data_contents.structure.reduce((_is_edited_structure, _structure, _structure_idx) => {
                if (!_is_edited_structure) {
                    const _origin_campare_data = Object.entries(_editing_check_field_object).reduce((_campare_object, [ _campare_key ]) => {
                        if (_structure[_campare_key]) _campare_object[_campare_key] = _structure[_campare_key]
                        return _campare_object
                    }, {})

                    const _editable_campare_data = Object.entries(_origin_campare_data).reduce((_campare_object, [ _campare_key ]) => {
                        const _campare_object_value = this.editable_sub_data_contents.structure[_structure_idx][_campare_key]
						_campare_object[_campare_key] = _campare_object_value
                        return _campare_object
                    }, {})

					const isEmptyValue = Object.values(_editable_campare_data).some(_edit_value => this.isFieldEmpty(_edit_value))
					if (!isEmptyValue) {
						_is_edited_structure = !isEqual(_editable_campare_data, _origin_campare_data);
					}
                }
                return _is_edited_structure
            }, false)

            this.validate_sub_type_translation()
            this.is_edited_sub_data_contents = _is_sub_data_contents_edited
        }, 250),
        changeEditingSubElementContents: debounce(function () {
			let _is_element_edited = this.sub_data.sub_data_contents.structure.reduce((_is_edited_element_contents, _structure, _structure_index) => {
				if (!_is_edited_element_contents && _structure.element_contents) {
					const _origin_element = _structure.element_contents
					let _edited_element = this.editable_sub_data_contents.structure[_structure_index].element_contents
                    
					if (typeof _origin_element === 'object') {
						if (!Array.isArray(_origin_element) && !isFieldEmpty(_edited_element)) {
							_is_edited_element_contents = !isEqual(_origin_element, _edited_element)
						} else {
							_is_edited_element_contents = _origin_element.reduce((_is_edited_element_structure, { structure }, _element_idx) => {
								if (!_is_edited_element_structure && !isFieldEmpty(_edited_element[_element_idx].structure)) {
									_is_edited_element_structure = !isEqual(structure, _edited_element[_element_idx].structure)
								}
								
								return _is_edited_element_structure
							}, false)
						}
					}
				}

				return _is_edited_element_contents
			}, false)
			this.is_edited_sub_element_contents = _is_element_edited
			
            this.validate_sub_type_translation()
		}, 500),
        validate_sub_type_translation () {
            /**
             * Table에 대한 validation check function은 EditingTranslationTable.vue 컴포넌트에 있음
             */
            if (this.sub_type === 'radio') {
                this.has_radio_translation = this.validate_radio_translation()
            } else if (this.sub_type === 'checkbox') {
                this.has_checkbox_translation = this.validate_checkbox_translation()
            } else if (this.sub_type === 'textbox') {
                this.has_textbox_translation = this.validate_textbox_translation()
            }
        },
        validate_radio_translation () {
            if (this.sub_type === 'radio' && !!this.editable_sub_data_contents.structure) {
				return this.editable_sub_data_contents.structure.reduce((has_translation, structure) => {
					if (has_translation && !!structure) {
						if (!this.isFieldEmpty(structure.text)) {
							has_translation = !this.isFieldEmpty(structure.text_ea) && !this.isFieldEmpty(structure.text_ca)
						}
					}

					if (has_translation && structure.element_contents && structure.element_contents.length) {
						has_translation = structure.element_contents.reduce((has_translation_element, element) => {
                            
							let translation_field = []
							if (['input_text', 'input_number'].includes(element.type)) {
								translation_field = ['pre_text', 'after_text', 'placeholder']
							} else if (element.type === 'checkbox') {
								translation_field = ['text', 'placeholder']
							} else if (element.type === 'table') {
								if (element.table_header) {
									translation_field = [ ...element.table_header ]
								}
							}
							
							if (['input_text', 'input_number', 'checkbox'].includes(element.type)) {
								if (has_translation_element) {
									translation_field.forEach((_field) => {
										if (has_translation_element && !this.isFieldEmpty(element.structure[_field])) {
											has_translation_element = !this.isFieldEmpty(element.structure[`${_field}_ca`]) && !this.isFieldEmpty(element.structure[`${_field}_ea`])
										}
									})
								}
							} else {
								// table
								if (has_translation_element) {
                                    translation_field.forEach(() => {
										element.structure.forEach(structure => {
											if (has_translation_element && !!structure.noteditables && !!structure.noteditables.length) {
												let _noteditables = new Set(...structure.noteditables)
												_noteditables = [ ..._noteditables ]
												_noteditables.forEach(_noteditable => {
													if (has_translation_element && structure[_noteditable]) {
														has_translation_element = !this.isFieldEmpty(structure[`${_noteditable}_ca`]) && !this.isFieldEmpty(structure[`${_noteditable}_ea`])
													}
												});
											}

											if (has_translation_element && !!structure.dropdown && !!Object.keys(structure.dropdown).length) {
												const _dropdownKeis = Object.keys(structure.dropdown)										
												if (_dropdownKeis.length) {
													has_translation_element = translation_field.every(value => {
														if (_dropdownKeis.includes(value)) {
															return _dropdownKeis.includes(value) &&
															_dropdownKeis.includes(`${value}_ca`) &&
															_dropdownKeis.includes(`${value}_ea`)
														} else {
															return true
														}
													})
												}
											}

											if (has_translation_element && !!structure.placeholder && Object.keys(structure.placeholder).length) {
												const _placeholders = Object.keys(structure.placeholder)
												if (_placeholders.length) {
													has_translation_element = translation_field.every(value => {
														if (_placeholders.includes(value)) {
															return _placeholders.includes(value) &&
															_placeholders.includes(`${value}_ca`) &&
															_placeholders.includes(`${value}_ea`)
														} else {
															return true
														}
													})
												}
											}
										});
									})
								}
							}

							return has_translation_element
						}, true)
					}

					return has_translation
				}, true)
			} else {
				return true
			}
        },
		validate_checkbox_translation () {
			if (this.sub_type === 'checkbox' && this.editable_sub_data_contents.structure) {
				return this.editable_sub_data_contents.structure.reduce((has_translation, structure) => {

					if (has_translation && !isFieldEmpty(structure.text)) {
						has_translation = !isFieldEmpty(structure.text_ca) || !isFieldEmpty(structure.text_ca)
					}

					if (has_translation && !isFieldEmpty(structure.placeholder)) {
						has_translation = !isFieldEmpty(structure.placeholder_ca) || !isFieldEmpty(structure.placeholder_ea)
					}
					
					return has_translation
				}, true)
			} else {
				return true
			}
		},
		validate_textbox_translation () {
			if (this.sub_type === 'textbox' && this.editable_sub_data_contents) {
				const { placeholder, placeholder_ea, placeholder_ca } = this.editable_sub_data_contents
				return !!placeholder && placeholder !== '' && !!placeholder_ea && placeholder_ea !== '' && !!placeholder_ca && placeholder_ca !== ''
			} else {
				return true
			}
		},
		validateTranslationInput (input) {
			return /^[\u4e00-\u9fa5_-a-za-z0-9\s]+$/g.test(input)
		}
    }
}